export default import.meta.ROLLDOWN_FILE_URL_5G99IwyL$knLgb1_rwqsQw